<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs [url]="'lead,Lead Import'"
            [url]="productImport?'lead,Lead Import':'lead,Lead Import'"
            [currentPage]="productImport?'Lead,Lead Import':'Lead, Lead Export'" [header]="'primary'">
        </calsoft-breadcrumbs>
        <div fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <button [attr.guide]="'lead-import-btn-1-1' + '__' + sanitizeUrl(url)" (click)="back()" matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            {{title}}
                        </div>
                    </div>

                    
                    <div *ngIf="!productImport" class="editSets" [formGroup]="firstFormGroup">
                        <div class="products-padding">
                            <div class="editSets">

                                <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                    <span>Export Excel
                                    </span>
                                </div>
                                <div class="products-padding">
                                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                                      
                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Attribute Set</mat-label>
                                            <mat-select formControlName="attributeSet"
                                                [disableOptionCentering]="true" required #singleSelect>
                                                <mat-option>
                                                    <ngx-mat-select-search name="Attribute Search"
                                                        ngDefaultControl
                                                        [formControl]="attributeFilterControl"
                                                        placeholderLabel="Attribute Search"
                                                        [preventHomeEndKeyPropagation]="true"
                                                        noEntriesFoundLabel="No data found">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option
                                                    *ngFor="let item of filteredAttributeList; let i=index;"
                                                    [value]="item.attributeSetId">
                                                    {{item.attributeSetName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngFor="let validation of createAttributeValidations.attributeSet">
                                                <mat-error class="error-message"
                                                    *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                    {{validation.message}}
                                                </mat-error>
                                            </mat-error>
                                        </mat-form-field>
                                    
                                    </div>
                                </div>

                                <div class="btn" fxLayoutAlign="end center">
                                    <button [attr.guide]="'lead-import-btn-2-1' + '__' + sanitizeUrl(url)" [disabled]="textAdd !='Download Template'" (click)="getExcelTemplate()"
                                        mat-raised-button>
                                        {{textAdd}}
                                        <mat-icon *ngIf="textAdd !='Download Template' ">
                                            <mat-spinner color="primary" diameter="20">
                                            </mat-spinner>
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="productImport" class="padding-10" fxLayout="column" fxLayoutGap="10px">
                        <div class="editSets" [formGroup]="firstFormGroup">
                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                <span>Lead Excel

                                </span>
                            </div>
                            <div class="products-padding"  fxLayout="row" fxLayoutAlign="start center">

                                <mat-stepper orientation="{{orientation}}" style="width: 100%;"
                                 fxFlex [linear]="isLinear" #stepper>
                                  
                                    <mat-step [stepControl]="secondFormGroup" label="Import Excel">
                                        <form [formGroup]="secondFormGroup">

                                           <input [attr.guide]="'lead-import-inp-3-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'"type="file" #myInput ng2FileSelect [uploader]="uploader"
                                                *ngIf="!excelTemplateUploaded"/>
                                            <div fxLayout="row" class="padding-10" fxLayoutAlign="start center"
                                                fxLayoutGap="5px" *ngIf="!excelTemplateUploaded">

                                                <ng-container *ngIf="uploader?.queue?.length>0">
                                                    <button [attr.guide]="'lead-import-btn-4-1' + '__' + sanitizeUrl(url)" [disabled]="text !='Upload'" (click)="upload()"
                                                        mat-raised-button>
                                                        {{text}}
                                                        <mat-icon *ngIf="text !='Upload' ">
                                                            <mat-spinner color="primary" diameter="20">
                                                            </mat-spinner>
                                                        </mat-icon>
                                                    </button>
                                                </ng-container>
                                            </div>

                                          

                                            <div class="products-padding" fxLayout="column" *ngIf="excelTemplateUploaded" fxLayoutGap="12px">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="font-weight: bold; font-size: 16px;">
                                                    <span style="color: #4caf50;">Successfully Uploaded: {{ successList?.length || 0 }}</span>
                                                    <span>|</span>
                                                    <span style="color: #f44336;">Failed to Upload: {{ failedList?.length || 0 }}</span>
                                                </div>
                                                <div style="margin-top: 8px;">
                                                    File Uploaded Successfully. Proceed to Next Step.
                                                </div>
                                            </div>


                                            <div class="products-padding" fxLayout="column"
                                                *ngIf="excelTemplateUploaded && failedList && failedList.length > 0">
                                                <div fxLayout="row" style="font-weight: bold; margin-bottom: 8px;">


                                                    Failure List details:

                                                </div>


                                                <div fxLayout="row" >
                                                    <table fxFlex style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                                                        <thead>
                                                            <tr style="text-align: left; background-color: #f5f5f5;">
                                                                <th style="padding: 8px; border: 1px solid #ddd;">Name</th>
                                                                <th style="padding: 8px; border: 1px solid #ddd;">Phone Number</th>
                                                                <th style="padding: 8px; border: 1px solid #ddd;">Reason</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of failedList">
                                                                <td style="padding: 8px; border: 1px solid #ddd;">{{item.Name || item.CompanyName || '-'}}</td>
                                                                <td style="padding: 8px; border: 1px solid #ddd;">{{item.PhoneNumber || item.Secondaryphoneno || '-'}}</td>
                                                                <td style="padding: 8px; border: 1px solid #ddd; color: #f44336;">{{item.reason || item.Message || 'Validation failed'}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>


                                            <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                                <button [attr.guide]="'lead-import-btn-5-1' + '__' + sanitizeUrl(url)" *ngIf="!excelTemplateUploaded" mat-raised-button [disabled]="textAdd !='Download Template'" (click)="getExcelTemplate()"
                                                mat-raised-button>
                                                {{textAdd}}
                                                <mat-icon *ngIf="textAdd !='Download Template' ">
                                                    <mat-spinner color="primary" diameter="20">
                                                    </mat-spinner>
                                                </mat-icon>
                                            </button>
                                                <!-- <button [attr.guide]="'lead-import-btn-6-1' + '__' + sanitizeUrl(url)" ngStyle.lt-sm="width: 100%;"  (click)="goBack(stepper)" mat-raised-button>Back</button> -->
                                                <button [attr.guide]="'lead-import-btn-7-1' + '__' + sanitizeUrl(url)" ngStyle.lt-sm="width: 100%;"  (click)="goToStep3(stepper)" mat-raised-button
                                                    color="primary">Next</button>

                                            </div>
                                        </form>

                                    </mat-step>

                                    <!-- <mat-step [stepControl]="thirdFormGroup" label="Upload Image">
                                        <ng-container *ngIf="!zipStatus">
                                            <calsoft-zip-import (onSuccess)="getResult($event)"
                                                [productId]="productIdUploaded"
                                                [id]="firstFormGroup.value.attributeSet">
                                            </calsoft-zip-import>
                                        </ng-container>

                           
                                    <div class="products-padding" fxLayout="column" *ngIf="zipStatus&&zipFailedList.length>0">

                                            <div fxLayout="row">


                                                Failure List:

                                            </div>
                                            <div fxLayout="row">
                                                <table fxFlex>
                                                    <tr>
                                                        <th>Name</th>

                                                    </tr>
                                                    <tr *ngFor="let item of zipFailedList ">
                                                        <td>{{item}}</td>

                                                    </tr>

                                                </table>
                                            </div>
                                    </div>


                                        <div class="products-padding" fxLayout="row" *ngIf="zipStatus">
                                            File Uploaded SuccessFully Procced to Next Step
                                        </div>


                                        <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                            <button [attr.guide]="'lead-import-btn-8-1' + '__' + sanitizeUrl(url)" ngStyle.lt-sm="width: 100%;" (click)="goForward(stepper)" mat-raised-button
                                                color="primary">Next</button>
                                        </div>
                                    </mat-step> -->

                                    <mat-step>
                                        <ng-template matStepLabel>Done</ng-template>
                                        <p>You are now done.</p>

                                        <p>Excel Import Completed SuccessFully</p>
                                        <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                            <!-- <button [attr.guide]="'lead-import-btn-9-1' + '__' + sanitizeUrl(url)" (click)="goBack(stepper)" mat-raised-button>Back</button> -->
                                            <button [attr.guide]="'lead-import-btn-10-1' + '__' + sanitizeUrl(url)" ngStyle.lt-sm="width: 100%;" (click)="goToProductPage()" mat-raised-button
                                                color="primary">Next</button>
                                        </div>
                                    </mat-step>

                                </mat-stepper>



                            </div>

                        </div>





                    </div>
                </div>

            </div>
        </div>
    </div>